import {
	PROCEDURE_INFO_RECEIVED,
	ACCOUNTED_CARDHOLDERS_RECEIVED,
	UNACCOUNTED_CARDHOLDERS_RECEIVED,
	RESET_EVACUATION
} from "./actionTypes";

import { evacuationService } from "client-app-core";

/**
 * Streams personnel data for a given procedure and dispatches updates
 * based on whether the personnel are accounted or unaccounted.
 */
export const subscribeProcedureUpdates = () => {
	return (dispatch) => {
		const handlePersonnelUpdate = (err, res) => {
			if (err) {
				console.error("Evacuation stream error:", err);
				return;
			}

			if (res?.type === "personnel") {
				const { type, new_val } = res?.data;
				if (!["initial", "add", "change"].includes(type) || !new_val) return;

				const actionType = new_val.isAccounted
					? ACCOUNTED_CARDHOLDERS_RECEIVED
					: UNACCOUNTED_CARDHOLDERS_RECEIVED;

				dispatch({ type: actionType, payload: new_val });
			}
			if (res?.type === "procedure") {
				const { isActive, timerStartTimeStamp, id } = res?.data?.new_val;
				dispatch({
					type: PROCEDURE_INFO_RECEIVED,
					payload: { isProcedureActive: isActive, procedureStartTime: timerStartTimeStamp, procedureId: id }
				});
			}
		};

		evacuationService.subscribeProcedureUpdates(handlePersonnelUpdate).then((subscription) => {
			dispatch({ type: PROCEDURE_INFO_RECEIVED, payload: { subscriptionChannel: subscription.channel } });
		});
	};
};

/**
 * Stores initial procedure info into state.
 * @param {Object} info - Procedure details including procedureId, orgId, etc.
 */
export const receiveProcedureInfo = (info) => ({
	type: PROCEDURE_INFO_RECEIVED,
	payload: info
});

export const resetEvacuation = () => ({
	type: RESET_EVACUATION,
	payload: {}
});
